// W47b (2026-10-21): the approved "Gift history" card (data-component
// "gift-history") from the W47 `lastGift` / `pendingGift`. MEASURED: no
// gift history source exists on the api-server (notAvailable
// NO_GIFT_HISTORY_SOURCE), so the card says "No gift on record" and why,
// never the sample "No previous gifts in this sample".
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';
import { GIFT_NO_HISTORY, type GiftEligibilityView } from '../liveModel.js';

export function LiveGiftHistory({ view, firstName }: { view: GiftEligibilityView; firstName: string }): ReactNode {
  const last = view.lastGift;
  const pending = view.pendingGift;
  return (
    <section className="card" data-component="gift-history" data-testid="gifts-live-history">
      <div className="section-heading">
        <h3>Gift history</h3>
        <span>{firstName ? `${firstName}’s account` : 'HubSpot contact'}</span>
      </div>
      {last.at ? (
        <ul className="gift-history-list">
          <li>
            <strong>Last gift</strong>
            <p>{last.at}{last.source ? ` · ${last.source}` : ''}</p>
            {pending.value ? <small>Pending gift: {pending.value}</small> : null}
          </li>
        </ul>
      ) : (
        <div className="gift-empty">
          <span className="history-icon"><Icon id="box" /></span>
          <div>
            <strong data-testid="gifts-no-history">{GIFT_NO_HISTORY}</strong>
            <p>
              {last.notAvailable === 'NO_GIFT_HISTORY_SOURCE'
                ? 'No gift history source is connected on this deployment. Requested, attached and shipped gifts will appear here with their dates and responsible rep once it is.'
                : 'No requested, attached or shipped gift is recorded for this contact.'}
            </p>
          </div>
        </div>
      )}
    </section>
  );
}
